import api from "./api";

const knowledgeService = {
  // Get knowledge list for agent
  getKnowledge: async (agentId) => {
    try {
      const response = await api.get(`/knowledge/agents/${agentId}/knowledge`);
      return response.data;
    } catch (error) {
      console.error("Error fetching knowledge:", error);
      // Return empty state for fallback
      return {
        status: "success",
        knowledge_items: [],
        summary: {
          total_items: 0,
          manual_items: 0,
          document_items: 0,
          total_chunks: 0,
        },
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_items: 0,
          items_per_page: 20,
        },
      };
    }
  },

  // Add manual knowledge content
  addManualKnowledge: async (agentId, data) => {
    try {
      const response = await api.post(
        `/knowledge/agents/${agentId}/knowledge/manual`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error adding manual knowledge:", error);
      throw error;
    }
  },

  // Upload document knowledge
  uploadDocument: async (agentId, formData, onUploadProgress) => {
    try {
      const response = await api.post(
        `/knowledge/agents/${agentId}/knowledge/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: onUploadProgress,
          timeout: 90000, // 90 seconds - balanced for UX and processing
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading document:", error);
      throw error;
    }
  },

  // Update manual knowledge content
  updateManualKnowledge: async (agentId, itemId, data) => {
    try {
      const response = await api.put(
        `/knowledge/agents/${agentId}/knowledge/${itemId}`,
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error updating manual knowledge:", error);
      throw error;
    }
  },

  // Delete knowledge item
  deleteKnowledge: async (agentId, itemId) => {
    try {
      const response = await api.delete(
        `/knowledge/agents/${agentId}/knowledge/${itemId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting knowledge:", error);
      throw error;
    }
  },

  // Search knowledge content
  searchKnowledge: async (agentId, data) => {
    try {
      const response = await api.post(`/knowledge/agents/${agentId}/search`, {
        query: data.query,
        limit: data.limit || 5,
        format: data.format || "context",
      });
      return response.data;
    } catch (error) {
      console.error("Error searching knowledge:", error);
      throw error;
    }
  },
};

export default knowledgeService;
